import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, LogIn } from "lucide-react";
import PhotonLogo from "../components/PhotonLogo";
import { useToast } from "../hooks/use-toast";
import { adminLogin } from "../api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("pp_admin_token", res.token);
      localStorage.setItem("pp_admin_email", res.email);
      toast({ title: "Welcome back 👋" });
      navigate("/admin");
    } catch {
      toast({ title: "Login failed", description: "Invalid email or password." });
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-slate-200 pl-11 pr-4 py-3 text-sm outline-none focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9]/20";

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "linear-gradient(135deg,#050C17,#0D1B2A)" }}>
      <div className="w-full max-w-md bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
        <div className="flex justify-center mb-6"><PhotonLogo variant="dark" /></div>
        <h1 className="text-2xl font-extrabold text-[#0D1B2A] text-center">Admin Dashboard</h1>
        <p className="text-sm text-[#475569] text-center mt-1">Sign in to manage PhotonPE</p>
        <form onSubmit={onSubmit} className="mt-7 space-y-4">
          <div className="relative">
            <Mail size={17} className="absolute left-4 top-3.5 text-[#64748B]" />
            <input className={field} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="relative">
            <Lock size={17} className="absolute left-4 top-3.5 text-[#64748B]" />
            <input className={field} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 text-white font-semibold py-3.5 rounded-xl disabled:opacity-70" style={{ background: "linear-gradient(90deg,#06B6D4,#10B981)" }}>
            {loading ? "Signing in…" : "Sign In"} <LogIn size={16} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
